module.exports = __webpack_public_path__ + "static/img/NZ.70edaae8.png";